import { get, set, del } from 'idb-keyval'
import { StorageType } from './StorageService';
import { storageErrorTracker } from './storage/StorageErrorTracker';

const noop = () => {};

export default class IDBStorage implements StorageType {
	async getItem( key: string ) {
		return storageErrorTracker.wrapIndexedDBOperation(
			() => ( get<string>( key ) ).then( result => result || null ),
			'IDBStorage',
			'read'
		).catch( () => null );
	}

	async setItem( key: string, value: string ) {
		await storageErrorTracker.wrapIndexedDBOperation(
			() => set( key, value ),
			'IDBStorage',
			'write'
		).catch( noop );
	}

	async removeItem( key: string ) {
		await storageErrorTracker.wrapIndexedDBOperation(
			() => del( key ),
			'IDBStorage',
			'delete'
		).catch( noop );
	}
}
